import {createSlice} from '@reduxjs/toolkit';
import {getUserData, USER_LOGOUT} from './user-actions';

/**
 * @typedef {object} TUserReducerInitialState
 * @property {boolean} isPending - Whether the user data is pending
 * @property {object|null} data - The user data
 * @property {string|null} error - If an error occurred, the error message
 * @property {object} segment - The segment data
 */
const initialState = {
    isPending: false,
    data: {
        /* eslint-disable camelcase */
        is_staff: false,
        can_view_comp_passes: false,
        can_view_employee_parking: false,
        can_manage_employee_parking: false,
        /* eslint-enable camelcase */
    },
    error: null,
    segment: {},
};

/**
 * User reducer
 */
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        [USER_LOGOUT]: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserData.fulfilled, (state, {payload}) => {
                state.isPending = false;
                state.data = payload;
                state.segment = {
                    email: payload.email,
                    /* eslint-disable camelcase */
                    user_id: payload.user_id,
                    operator_id: payload.operator_id || '',
                    /* eslint-enable camelcase */
                };
            })
            .addCase(getUserData.pending, (state) => {
                state.isPending = true;
            })
            .addCase(getUserData.rejected, (state, {payload}) => {
                state.isPending = false;
                state.error = payload.message;
            });
    },
});

export default userSlice.reducer;
